module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Buried-Knights-Templar-1.6431638.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Buried-Knights-Templar-1.jpg
// module id = DbwY
// module chunks = 0